import React from 'react';
import Skeleton from './Skeleton';
import './Skeleton.css';

/**
 * Business Listing Card Skeleton
 * Shows placeholder while business listing data loads
 */
export const BusinessListingSkeleton = () => (
  <div className="skeleton-listing">
    <Skeleton variant="rectangular" className="skeleton-listing-image" />
    <div className="skeleton-listing-content">
      <Skeleton variant="rounded" className="skeleton-listing-badge" />
      <Skeleton variant="text" className="skeleton-listing-title" />
      <Skeleton variant="text" className="skeleton-listing-description" />
      <Skeleton variant="text" className="skeleton-listing-description" />
      <div className="skeleton-listing-meta">
        <Skeleton variant="text" className="skeleton-listing-meta-item" />
        <Skeleton variant="text" className="skeleton-listing-meta-item" />
      </div>
    </div>
  </div>
);

/**
 * Business Listing Grid Skeleton
 * Shows multiple skeleton cards in a grid layout
 */
export const BusinessListingGridSkeleton = ({ count = 6 }) => (
  <div className="skeleton-grid">
    {Array.from({ length: count }).map((_, index) => (
      <BusinessListingSkeleton key={index} />
    ))}
  </div>
);

/**
 * Profile Section Skeleton
 */
export const ProfileSkeleton = () => (
  <div className="skeleton-profile">
    <Skeleton variant="circular" className="skeleton-profile-avatar" />
    <div className="skeleton-profile-info">
      <Skeleton variant="text" className="skeleton-profile-name" />
      <Skeleton variant="text" className="skeleton-profile-email" />
    </div>
  </div>
);

/**
 * Token Balance Skeleton
 */
export const TokenBalanceSkeleton = () => (
  <div className="skeleton-token-balance">
    <Skeleton variant="circular" className="skeleton-token-icon" />
    <Skeleton variant="text" className="skeleton-token-amount" />
  </div>
);

/**
 * Card Skeleton - Generic card placeholder
 */
export const CardSkeleton = ({ imageHeight = 180, lines = 3 }) => (
  <div className="skeleton-card">
    <Skeleton
      variant="rounded"
      className="skeleton-card-image"
      height={imageHeight}
    />
    <Skeleton variant="text" className="skeleton-card-title" />
    {Array.from({ length: lines }).map((_, index) => (
      <Skeleton key={index} variant="text" className="skeleton-card-text" />
    ))}
  </div>
);

/**
 * Table Row Skeleton
 */
export const TableRowSkeleton = ({ columns = 4 }) => (
  <div className="skeleton-table-row">
    {Array.from({ length: columns }).map((_, index) => (
      <Skeleton key={index} variant="text" className="skeleton-table-cell" />
    ))}
  </div>
);

/**
 * Table Skeleton - Multiple rows
 */
export const TableSkeleton = ({ rows = 5, columns = 4 }) => (
  <div className="skeleton-table">
    {Array.from({ length: rows }).map((_, index) => (
      <TableRowSkeleton key={index} columns={columns} />
    ))}
  </div>
);

/**
 * Navigation Skeleton
 */
export const NavigationSkeleton = ({ items = 5 }) => (
  <div className="skeleton-nav">
    {Array.from({ length: items }).map((_, index) => (
      <Skeleton key={index} variant="text" className="skeleton-nav-item" />
    ))}
  </div>
);

export default Skeleton;
